import { useAuth } from '@/auth/hyper-auth'
import axios from 'axios'
const overrideConfig = {
    baseURL: process.env.VUE_APP_COMMON_URL,
    namespace: process.env.VUE_APP_NAMESPACE,
    serviceGroup: process.env.VUE_APP_SERVICE
}

const service = {

    /* privacy */
    getDocumentVersions ({ locale, type }) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.get(`/v1/hyper-common/auth/docs/${locale}/${type}`)
    },
    getAgreementDocumentVersions ({ locale = 'ko' }) {
        return this.getDocumentVersions({ locale, type: 'agreement' })
    },
    getDocumentContent ({ locale, type, version }) {
        return axios.get(`${process.env.VUE_APP_HYPER_V3_CONTENT}/docs/${process.env.VUE_APP_NAMESPACE}/${locale}/${type}/${version}.json`)
    },
    getAgreementDocumentContent (version, locale) {
        return this.getDocumentContent({ locale, version, type: 'agreement' })
    },
    /** Summary */
    simpleExcel ({ usageAccountId, month }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.get(`/v1/hyper-common/download/summary/simple/${usageAccountId}/${month}`, { responseType: 'blob' })
    },
    detailCSV ({ usageAccountId, month }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.get(`/v1/hyper-common/download/summary/detail/${usageAccountId}/${month}`)
    },
    /** Summary & Invoice */
    getAvailableInvoice ({ usageAccountId, month }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.get(`/v1/hyper-common/invoice/${usageAccountId}/months/${month}`)
    },
    invoicePDF ({ usageAccountId, month, locale }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.get(`/v1/hyper-common/download/invoice/${usageAccountId}/${month}/${locale}/invoice.pdf`, { responseType: 'blob' })
    },
    /** All Consolidated */
    consolidatedAccountExcel ({ qtype, projectIdx, groupIdx, month }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('/v1/hyper-common/download/allConsolidated', { target: 'AllConsolidatedDownload', params: { qtype, projectIdx, groupIdx, month } }, {
            responseType: 'blob' })
    },
    /** Cost Pivot */
    createCostPivotFilter ({ userIdx, name, content }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('/v1/hyper-common/cost-pivot/filter', { userIdx, name, content })
    },
    fetchCostPivotFilter ({ costPivotFilterIdx }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.get(`/v1/hyper-common/cost-pivot/filter/${costPivotFilterIdx}`)
    },
    deleteCostPivotFilter ({ costPivotFilterIdx }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.delete(`/v1/hyper-common/cost-pivot/filter/${costPivotFilterIdx}`)
    },
    fetchCostPivotFilterNames ({ userIdx }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.get(`/v1/hyper-common/cost-pivot/filter/user/${userIdx}/names`)
    },
    fetchCustomDashboard: ({ userIdx }, serviceIdx) => {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('/v3/hyper-common/dashboard/retrievesummary', { userIdx })
    },
    saveCustomDashboard: ({ userIdx, coordinate }, serviceIdx) => {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('/v3/hyper-common/dashboard/summary', { userIdx, coordinate })
    },
    resetCustomDashboard: ({ userIdx, dashboardIdx }, serviceIdx) => {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('/v3/hyper-common/dashboard/reset', { userIdx, dashboardIdx })
    }
}

export {
    service,
    overrideConfig,
    useAuth
}
